import {
    buildMentionPillElement,
    resolveProfilePictureUrl,
} from '../../../../../components/MentionEditor/MentionEditorMentionBlot'

const URL_IN_TEXT_RE = /(?<!["'=])(https?:\/\/[^\s<]+)/gi

const escapeHtml = (value = '') =>
    String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')

const linkifyUrls = (text = '') =>
    String(text).replace(URL_IN_TEXT_RE, (rawUrl) => {
        const trimmed = rawUrl.replace(/[.,;:!?)\]}]+$/g, '')
        const trailing = rawUrl.slice(trimmed.length)
        if (!trimmed) return rawUrl
        return `<a href="${trimmed}" target="_blank" rel="noopener noreferrer">${trimmed}</a>${trailing}`
    })

/** Ensure Quill mention nodes render as avatar + name chips. */
export const enhanceCommentMentionsHtml = (html = '') => {
    const input = String(html || '')
    if (!input || typeof document === 'undefined') return input
    if (!input.includes('mention') && !input.includes('data-value')) {
        return input
    }

    try {
        const root = document.createElement('div')
        root.innerHTML = input

        root.querySelectorAll('span.mention').forEach((node) => {
            if (node.querySelector('.mention-editor-pill')) return

            const id = node.getAttribute('data-id') || ''
            const rawValue =
                node.getAttribute('data-value') ||
                node.querySelector('.ql-mention-value')?.textContent ||
                ''
            const displayName = String(rawValue).replace(/^@/, '').trim()
            if (!displayName) return

            const avatar = resolveProfilePictureUrl(
                node.getAttribute('data-avatar') || ''
            )

            node.querySelector('.ql-mention-denotation-char')?.remove()
            node.querySelector('.ql-mention-value')?.remove()
            node.innerHTML = ''
            node.appendChild(
                buildMentionPillElement({
                    id,
                    value: displayName,
                    avatar,
                })
            )
        })

        return root.innerHTML
    } catch {
        return input
    }
}

/** Render comment HTML; mentions become chips and plain URLs become links. */
export const toCommentHtml = (value = '') => {
    const raw =
        value == null
            ? ''
            : typeof value === 'string'
              ? value
              : typeof value === 'object'
                ? value.content || value.text || value.html || ''
                : String(value)
    let text = String(raw).trim()
    if (!text) return ''

    // Strip empty Quill blocks and whitespace that create huge list gaps
    text = text
        .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
        .replace(/<div>(?:\s|&nbsp;|<br\s*\/?>)*<\/div>/gi, '')
        .replace(/(?:<br\s*\/?>\s*)+$/gi, '')
        .replace(/>\s+</g, '><')
        .trim()
    if (!text) return ''

    let html
    if (/<[a-z][\s\S]*>/i.test(text)) {
        html = /<a\s/i.test(text) ? text : linkifyUrls(text)
    } else {
        html = `<p>${linkifyUrls(escapeHtml(text))}</p>`
    }

    return enhanceCommentMentionsHtml(html)
}
